/**
 * The page is imported from **its own module**, not from the `@pages` barrel — the barrel would pull
 * the register of drafts into the same chunk and undo the split by route.
 */
import { createFileRoute } from '@tanstack/react-router';

import { DraftViewPage } from '@pages/drafts/draft-page.js';
import { IamService } from '@units/iam';

/**
 * `/drafts/$draftId` — wiring only (`rules/frontend-fsd.mdc` rule 10).
 *
 * Гард тот же, что у перечня, — `document:read`, и по той же причине: раздел виден в навигации, его
 * существование не секрет. **Сам проект секрет**: проект чужой организации и идентификатор, не
 * называющий ничего, отвечают одинаково — `404`, и решает это сервер (контракт §4).
 *
 * Схемы адреса у экрана нет намеренно: состояния, которое стоило бы переслать ссылкой, здесь не
 * возникает — проект неизменен по построению (правка проекта = новая сборка, контракт §6), у него
 * нет ни страниц, ни даты, на которую его читают.
 */
export const Route = createFileRoute('/_authenticated/drafts/$draftId')({
  beforeLoad: IamService.IamGuards.requirePermission({
    permission: 'document:read',
    whenDenied: 'forbidden',
  }),
  component: DraftViewPage,
  staticData: { crumbKey: 'drafts.view.title' },
});
